import { render, staticRenderFns } from "./study.vue?vue&type=template&id=2fd44585&scoped=true&"
import script from "./study.vue?vue&type=script&lang=js&"
export * from "./study.vue?vue&type=script&lang=js&"
import style0 from "./study.vue?vue&type=style&index=0&id=2fd44585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd44585",
  null
  
)

export default component.exports